import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 600,
      "data-sign": "shop_manage_bind_account_modal",
      "title": _vm.t('GD店铺绑定主体')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "shop_manage_bind_account_form",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      },
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5BA2\u6237\u4EE3\u7801"),
      "prop": "customer_code",
      "label": _vm.t('客户代码')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.formData.customer_code,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7ED1\u5B9A\u4E3B\u4F53"),
      "prop": "account_code",
      "label": _vm.t('绑定主体')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "option-filter-prop": "children",
      "placeholder": _vm.t('请选择绑定主体')
    },
    model: {
      value: _vm.formData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account_code", $$v);
      },
      expression: "formData.account_code"
    }
  }, _vm._l(_vm.availableBodyList, function (item) {
    return _c('a-select-option', {
      key: item.account_code,
      attrs: {
        "value": item.account_code
      }
    }, [_vm._v(" " + _vm._s(item.account_code) + "-" + _vm._s(item.sign_body_name) + " ")]);
  }), 1), _c('span', {
    staticClass: "note-tip"
  }, [_vm._v(_vm._s(_vm.t('仅展示状态为「审核通过」的主体；一个店铺仅可绑定一个主体。')))])], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E97\u94FA\u540D\u79F0"),
      "prop": "shop_name",
      "label": _vm.t('店铺名称')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "maxLength": 50,
      "placeholder": _vm.t('请输入店铺名称（1~50字符）')
    },
    model: {
      value: _vm.formData.shop_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "shop_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.shop_name"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "shop_manage_bind_cancel",
      "id": "shop_manage_bind_cancel",
      "data-sign": "shop_manage_bind_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading,
      "data-permission": "shop_manage_bind_confirm",
      "id": "shop_manage_bind_confirm",
      "data-sign": "shop_manage_bind_confirm",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };